export const DEFAULT_TERMINAL_TIME_ZONE = 'Europe/Zurich';
export const TERMINAL_LOGICAL_ID_MAX_LENGTH = 31;
export const TERMINAL_NAME_MAX_LENGTH = 80;
